import { httpRequest } from "@services/http"

export type EngagementLaunchPolicyPayload = {
  launch_id: number
  percent: number
  margin?: number
  name?: string
}

export class CommandUpsertEngagementLaunchPolicy {
  async run(engagementId: number, data: EngagementLaunchPolicyPayload): Promise<void> {
    const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/engagements/${engagementId}/policies/budget/`
    await httpRequest(url, { method: "POST", body: data })
  }
}
